import classnames from "classnames";
import { useState } from "react";

import { AdjustImages } from "../../AdjustImages";
import { useImagePostModalStore } from "../../store";
import { useHandleFileSelection } from "../../UploadImages/hooks/useHandleFileSelection";
import { useMultiImageUpload } from "../../UploadImages/hooks/useMultiImageUpload";
import { MultiImageDropZone } from "../../UploadImages/MultiImageDropZone";

export const EmptyImages = () => {
  const [isAdjustImagesOpen, setIsAdjustImagesOpen] = useState(false);
  const { selectedFiles, uploadedImages } = useImagePostModalStore();
  const { handleFileSelection } = useHandleFileSelection(() =>
    setIsAdjustImagesOpen(true),
  );
  const { isDragActive, ...dropZoneProps } = useMultiImageUpload({
    handleFileSelection,
    selectedFiles,
    uploadedFilesCount: uploadedImages.length,
  });
  return (
    <div
      className={classnames(
        "flex size-full flex-col items-center justify-center rounded-md px-4 text-center",
        { "!bg-light-blue": isDragActive },
      )}
    >
      <MultiImageDropZone
        isDragActive={isDragActive}
        {...dropZoneProps}
        className="pb-0"
      />
      {isAdjustImagesOpen && (
        <AdjustImages onClose={() => setIsAdjustImagesOpen(false)} isOnTop />
      )}
    </div>
  );
};
